export default class ResponsiveHelper {
    public static onResize() {
        let self = this;

        $(window).on("resize", function () {
            self.setWrapMenu()
        }).resize();
    }

    public static setWrapMenu() {
        let device = {
            isTouch: 'ontouchstart' in window,
            isSmartphone: function () { return window.matchMedia("screen and (max-width:599px)").matches },
            isSmalltablet: function () { return window.matchMedia("screen and (min-width:600px) and (max-width:749px)").matches },
            isTablet: function () { return window.matchMedia("screen and (min-width:750px) and (max-width:1050px)").matches },
            isRetina: function () { return window.matchMedia("only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (min--moz-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min-device-pixel-ratio: 2), only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx)").matches },
            OS: {
                isAndroid: function () {
                    return (navigator.userAgent.indexOf("Edge") < 0 && navigator.userAgent.match(/Android/i)) ? true : false;
                },
                isIOS: function () {
                    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
                },
                isWindows: function () {
                    return (navigator.userAgent.indexOf("Edge") >= 0 || navigator.userAgent.match(/IEMobile/i)) ? true : false;
                }
            }
        };

        var $hoverlay = ".hoverlay",
            $openBtn = ".button-open-wrap",
            $closeBtn = ".button-close-wrap",
            $nav = ".navigation .main-nav",
            $navItem = ".navigation .list-item .item";

        if (device.isSmartphone() || device.isSmalltablet() || device.isTablet() ){

            $($openBtn).unbind().bind("click", function () {
                var delay = 0

                $($hoverlay).show();
                $("body").attr("data-overflow", "hidden");

                $($hoverlay).each(function () {
                    var $item = $(this);

                    setTimeout(function () {
                        $item.attr("data-show", "true");
                    }, delay += 70);

                    setTimeout(function () {
                        $($nav).attr("data-show", "true")
                        $($closeBtn).attr("data-show", "true")
                    }, 250);
                });

                setTimeout(function () {
                    $($navItem).each(function () {
                        var $item = $(this);

                        setTimeout(function () {
                            $item.attr("data-show", "true");
                        }, delay += 50);
                    });
                }, 220);
            });

            $($closeBtn + "," + ".hoverlay[data-color='black']").unbind().bind("click", function () {
                $("body").removeAttr("data-overflow");
                $($nav + "," + $navItem + "," + $closeBtn).removeAttr("data-show")
                setTimeout(function () {
                    $(".hoverlay[data-color='red']").removeAttr("data-show");
                }, 140);
                setTimeout(function () {
                    $(".hoverlay[data-color='blue']").removeAttr("data-show");
                    $(".hoverlay[data-color='black']").removeAttr("data-show");
                }, 210);
            });
        }
        else {
            $("body").removeAttr("data-overflow");
            $(".hoverlay").removeAttr("data-show");
            $($nav + "," + $navItem + "," + $closeBtn).removeAttr("data-show")
        }
    }
}